import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import projectsData from "../../config";
import { useParams } from "react-router-dom";
import { LuDot } from "react-icons/lu";
import { FaExternalLinkAlt } from "react-icons/fa";
import ProjectCard from "./ProjectCard";

const ProjectDetails = () => {
  const param = useParams();
  const [project, setProject] = useState(
    projectsData.find((ele) => ele.projectName === param.projectName)
  );

  useEffect(() => {
    try {
      setProject(() =>
        projectsData.find((ele) => ele.projectName === param.projectName)
      );
    } catch (err) {}
  }, [param]);

  return (
    <motion.div
      className="flex flex-col font-poppins min-w-[280px] w-full select-none h-[85vh] sx:h-max overflow-y-scroll transition-all duration-300  rounded-xl p-4 px-6 flex-grow"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <div className="font-bold flex flex-wrap justify-between font-poppins text-2xl sx:text-xl">
          {project.projectName}
          <div className="font-bold text-lg sx:text-md">{project.time}</div>
        </div>
      </motion.div>
      <motion.p
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
      >
        {project.detailOnCard}
      </motion.p>
      <motion.a
        href={project.projectLink}
        className="px-2 py-1 text-blue-600 flex gap-1 font-bold text-xl items-center"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6 }}
        target="_blank"
      >
        Go to {project.projectName} <FaExternalLinkAlt />
      </motion.a>
      <motion.p
        className="font-bold text-xl my-2"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8 }}
      >
        What I Did ?
      </motion.p>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1 }}
      >
        <div className="flex flex-col justify-center items-start text-[0.9rem]">
          {project.did.map((ele, index) => (
            <p className="flex items-center" key={index}>
              <LuDot className="text-3xl" />
              {ele}
            </p>
          ))}
        </div>
      </motion.div>
      <motion.p
        className="font-bold text-xl my-2"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.2 }}
      >
        Stack I used ?
      </motion.p>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.4 }}
      >
        <div className="flex flex-wrap justify-start items-center text-[0.9rem]">
          {project.stack.map((ele, index) => (
            <p className="flex items-center" key={index}>
              <LuDot className="text-3xl" />
              {ele}
            </p>
          ))}
        </div>
      </motion.div>
      <motion.p
        className="font-bold text-xl my-2"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.6 }}
      >
        What is the uniqueness ?
      </motion.p>
      <motion.p
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.8 }}
      >
        {project.uniqueness}
      </motion.p>
      <motion.p
        className="font-bold text-xl my-2"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 2 }}
      >
        Similar S/W
      </motion.p>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 2.2 }}
      >
        <div className="flex flex-wrap justify-start items-center text-[0.9rem]">
          {project.marketComparison.map((ele, index) => (
            <p className="flex items-center" key={index}>
              <LuDot className="text-3xl" />
              {ele}
            </p>
          ))}
        </div>
      </motion.div>
      <motion.p
        className="font-bold text-xl my-2"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 2.4 }}
      >
        Other Projects
      </motion.p>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 2.6 }}
      >
        <div className="flex flex-wrap h-96 justify-center gap-5">
          {projectsData.map((project, index) => {
            if (project.projectName !== param.projectName)
              return (
                <ProjectCard
                  key={index}
                  details={project.detailOnCard}
                  projectName={project.projectName}
                />
              );
          })}
        </div>
      </motion.div>
    </motion.div>
  );
};

export default ProjectDetails;
